import * as React from 'react';

import { Color } from '../../enums';
import { Icon } from '../icon/icon.component';

import { 
  ArtistDetails, 
  LabelsContainer, 
  Container, 
  ImageElement, 
  ImageContainer, 
  Subtitle, 
  Title, 
  StyledButton 
} from './artistTitle.styled';
import { ArtistTitleProps } from './artistTitle.types';

export const ArtistTitle: React.FC<ArtistTitleProps> = (props: ArtistTitleProps): JSX.Element => {
  const { title, subtitle, buttonLabel, buttonIcon, buttonAction, image, iconName, className }: ArtistTitleProps = props;

  return (
    <Container className={className}>
      <ArtistDetails>
        <ImageContainer $withImage={!!image}>
          {image && <ImageElement src={image} alt={title} />}
          {(iconName && !image) && <Icon name={iconName} size={50} color={Color.Error500} />}
        </ImageContainer>
        <LabelsContainer>
          <Title as="h1">{title}</Title>
          <Subtitle>{subtitle}</Subtitle>
        </LabelsContainer>
      </ArtistDetails>
      {!!(buttonLabel && buttonIcon && buttonAction) && (
        <StyledButton label={buttonLabel} icon={buttonIcon} onClick={buttonAction} />
      )}
    </Container>
  );
};
